import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty } from "lodash";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import {
  getCities as onGetCities,
  addNewCity as onAddNewCity,
  updateCity as onUpdateCity,
  deleteCity as onDeleteCity,
} from "store/actions";


//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
  Button,
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from "reactstrap";
import moment from "moment";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";

function City() {

  //meta title
  document.title = "Master >> Cities";

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [city, setCity] = useState(null);

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      status: (city && city.status) || '',
      name: (city && city.name) || '',
      weeklyOff: (city && city.weeklyOff) || '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter City Name"),
      status: Yup.string().required("Please Enter Status"),
      weeklyOff: Yup.string().required("Please Enter Weekly Off Day or Select No Off"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateCity = {
          _id: city ? city._id : '',
          status: values.status == 'true' ? true : false,
          name: values.name,
          weeklyOff: values.weeklyOff,
        };
        // update order
        dispatch(onUpdateCity(updateCity));
        validation.resetForm();
      } else {

        const newCity = {
          status: values["status"] == "true" ? true : false,
          name: values["name"],
          weeklyOff: values["weeklyOff"],
        };
        // save new order
        dispatch(onAddNewCity(newCity));
        validation.resetForm();
      }
      toggle();
    },
  });


  const toggleViewModal = () => setModal1(!modal1);

  const dispatch = useDispatch();

  const selectCityState = (state) => state.City;
  const CityProperties = createSelector(
    selectCityState,
    (City) => ({
      cities: City.cities
    })
  );

  const { cities } = useSelector(CityProperties);

  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    dispatch(onGetCities());
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(cities) && !!isEdit) {
      setIsEdit(false);
    }
  }, [cities]);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setCity(null);
    } else {
      setModal(true);
    }
  };

  const handleCityClick = arg => {
    const city = arg;
    setCity({
      _id: city._id,
      status: '' + city.status,
      name: city.name,
      weeklyOff: '' + city.weeklyOff,
    });

    setIsEdit(true);

    toggle();
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (city) => {
    setCity(city);
    setDeleteModal(true);
  };

  const handleDeleteCity = () => {
    if (city && city._id) {
      dispatch(onDeleteCity(city._id));
      setDeleteModal(false);
    }
  };
  const handleCityClicks = () => {
    setIsEdit(false);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: () => <div className="form-check font-size-16" >
          <input className="form-check-input" type="checkbox" id="checkAll" />
          <label className="form-check-label" htmlFor="checkAll"></label>
        </div>,
        accessor: '#',
        width: '20px',
        filterable: true,
        Cell: (cellProps) => (
          <div className="form-check font-size-16" >
            <input className="form-check-input" type="checkbox" id="checkAll" />
            <label className="form-check-label" htmlFor="checkAll"></label>
          </div>
        )
      },
      {
        Header: 'Name',
        accessor: 'name',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.name}
          </>;
        }
      },
      {
        Header: 'Status',
        accessor: 'status',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.status ? 'Active' : 'Inactive'}
          </>;
        }
      },
      {
        Header: 'Action',
        accessor: 'action',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const cityData = cellProps.row.original;
                  handleCityClick(cityData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
              {/* <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const orderData = cellProps.row.original;
                  onClickDelete(orderData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link> */}
            </div>
          );
        }
      },
    ],
    []
  );

  return (
    <React.Fragment>

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteCity}
        onCloseClick={() => setDeleteModal(false)}
        title="City"
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Masters" breadcrumbItem="Cities" />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={cities}
                      isGlobalFilter={true}
                      isAddOptions={true}
                      handleOrderClicks={handleCityClicks}
                      customPageSize={10}
                      isPagination={true}
                      filterable={false}
                      iscustomPageSizeOptions={true}
                      tableClass="align-middle table-nowrap table-check"
                      theadClass="table-light"
                      pagination="pagination pagination-rounded justify-content-end mb-2"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit City" : "Add City"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col className="col-12">



                    <div className="mb-3">
                      <Label>City Name</Label>
                      <Input
                        name="name"
                        type="text"
                        placeholder="City Name"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ''}
                        invalid={
                          validation.touched.name && validation.errors.name ? true : false
                        }
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                      ) : null}
                    </div>



                    <div className="mb-3">
                      <Label>Status</Label>
                      <Input
                        name="status"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.status}

                      >
                        <option>Select Status</option>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </Input>
                      {validation.touched.status && validation.errors.status ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.status}</FormFeedback>
                      ) : null}
                    </div>

                    <div>
                      <Label>Weekly Off Day</Label>
                      <Input
                        type="select"
                        name="weeklyOff"
                        id="weeklyOff"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.weeklyOff}
                        invalid={
                          validation.touched.weeklyOff && validation.errors.weeklyOff ? true : false
                        }
                      >
                        <option >Select Weekly Off Day</option>
                        <option value="-1">No Off</option>
                        <option value="0">Sunday</option>
                        <option value="1">Monday</option>
                        <option value="2">Tuesday</option>
                        <option value="3">Wednesday</option>
                        <option value="4">Thursday</option>
                        <option value="5">Friday</option>
                        <option value="6">Saturday</option>
                        
                      </Input>
                      {validation.touched.weeklyOff && validation.errors.weeklyOff ? (
                        <FormFeedback type="invalid">{validation.errors.weeklyOff}</FormFeedback>
                      ) : null}
                    </div>
                    
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end mt-2">
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                      >
                        Save
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}
City.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default City;